<div class="container-fluid pt-3">
	<jhi-collapsible heading="{{translateService.instant('basic-details.title')}}">
		<div class="container-fluid">
			<div class="row mt-1" *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION">
				<div class="col-3">
					<label class="fw-bold" jhiTranslate="basic-details.preferred-name">Preferred Name:</label>
				</div>
				<div class="col text-wrap"><truncate-span [textInput]="germplasm?.preferredName" [maxLength]="500"></truncate-span></div>
			</div>
			<div class="row mt-1">
				<div class="col-3">
					<label class="fw-bold" jhiTranslate="basic-details.gid">GID:</label>
				</div>
                <div class="col"><truncate-span [textInput]="germplasm?.gid"></truncate-span></div>
			</div>
			<div class="row mt-1">
				<div class="col-3">
					<label class="fw-bold" jhiTranslate="basic-details.guid">GUID:</label>
				</div>
				<div class="col"><truncate-span [textInput]="germplasm?.germplasmUUID"></truncate-span></div>
			</div>
			<div class="row mt-1">
				<div class="col-3">
					<label class="fw-bold" jhiTranslate="basic-details.group-id">Group ID:</label>
				</div>
				<div class="col"><a *ngIf="germplasm && germplasm?.groupId !== 0" [href]="this.germplasmDetailsUrlService.getUrl(germplasm?.groupId)" target="_blank">{{germplasm?.groupId}}</a></div>
			</div>
			<div class="row mt-1">
				<div class="col-3">
					<label class="fw-bold" jhiTranslate="basic-details.created-by">Created By:</label>
				</div>
				<div class="col">{{germplasm?.createdBy}}</div>
			</div>
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-curved table-fixed mt-3">
					<thead>
					<tr>
						<th scope="col" jhiTranslate="basic-details.created-date">Created Date</th>
						<th scope="col" jhiTranslate="basic-details.location">Location</th>
						<th scope="col" jhiTranslate="basic-details.reference">Reference</th>
						<th scope="col" jhiTranslate="germplasm-details.actions" *jhiHasAnyAuthority="EDIT_BASIC_DETAILS_ACTIONS_PERMISSIONS" class="fit">Actions</th>
					</tr>
					</thead>
					<tbody>
					<tr>
						<td>{{germplasm?.creationDate}}</td>
						<td>{{germplasm?.breedingLocation}}</td>
						<td class="word-wrap">{{germplasm?.reference}}</td>
						<td class="fit">
							<button class="btn btn-outline-info btn-sm me-2" (click)="editGermplasmBasicDetails()" *jhiHasAnyAuthority="EDIT_BASIC_DETAILS_PERMISSIONS">
								<i class="fa fa-edit fa-fa-md" aria-hidden="true"></i>
							</button>
							<button class="btn btn-outline-info btn-sm" (click)="openGermplasmBasicDetailsAuditModal()" *jhiHasAnyAuthority="GERMPLASM_AUDIT_PERMISSION">
								<i class="fa fa-list fa-md" aria-hidden="true"></i>
							</button>
						</td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
	</jhi-collapsible>
	<jhi-collapsible *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION" heading="{{translateService.instant('basic-details.names.title')}}">
       <div class="row">
           <div class="row mb-3">
               <div class="col d-flex justify-content-end">
                   <button class="btn btn-outline-info" *jhiHasAnyAuthority="MODIFY_NAMES_PERMISSIONS" (click)="createGermplasmName()"><i class="fa fa-asterisk fa-md" aria-hidden="true"></i> {{ 'new' | translate }}</button>
               </div>
           </div>
       </div>
		<div class="container-fluid">
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-curved table-fixed">
					<thead>
					<tr>
						<th scope="col" jhiTranslate="basic-details.names.name-type" style="width: 13%">Name type</th>
						<th scope="col" jhiTranslate="basic-details.names.name-description" style="width: 15%">Name Description</th>
						<th scope="col" jhiTranslate="basic-details.names.value">Value</th>
						<th scope="col" jhiTranslate="basic-details.names.location">Location</th>
						<th scope="col" jhiTranslate="basic-details.names.date">Date</th>
						<th scope="col" jhiTranslate="basic-details.names.preferred">Preferred</th>
						<th scope="col" jhiTranslate="germplasm-details.actions" *jhiHasAnyAuthority="NAMES_ACTIONS_PERMISSIONS" class="fit">Actions</th>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let name of germplasm?.names">
						<td>{{name.nameTypeCode}}</td>
						<td>{{name.nameTypeDescription}}</td>
						<td class="word-wrap"><truncate-span [textInput]="name.name" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
						<td>{{name.locationName}}</td>
						<td>{{name.date}}</td>
						<td>{{name.preferred ? 'Yes' : 'No'}}</td>
						<td class="fit" *jhiHasAnyAuthority="NAMES_ACTIONS_PERMISSIONS">
							<button class="btn btn-outline-info btn-sm me-2" (click)="editGermplasmName(name)" *jhiHasAnyAuthority="MODIFY_NAMES_PERMISSIONS">
								<i class="fa fa-edit fa-md" aria-hidden="true"></i>
							</button>
							<button class="btn btn-outline-info btn-sm me-2" (click)="deleteGermplasmName(name)" *jhiHasAnyAuthority="MODIFY_NAMES_PERMISSIONS">
								<i class="fa fa-trash fa-md" aria-hidden="true"></i>
							</button>
							<button class="btn btn-outline-info btn-sm" (click)="openGermplasmNameAuditModal(name)" *jhiHasAnyAuthority="GERMPLASM_AUDIT_PERMISSION">
								<i class="fa fa-list fa-md" aria-hidden="true"></i>
							</button>
						</td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
	</jhi-collapsible>
	<jhi-collapsible heading="{{translateService.instant('basic-details.germplasm-origin.title')}}">
		<div class="container-fluid pb-3">
			<div class="row">
				<div class="col">
                    <div class="custom-scroll-style" style="overflow-y: auto; width: 100%">
                    <table class="table table-striped table-bordered table-curved"  *ngIf="hasGermplasmOrigin() else nogermplasmorigin">
						<thead>
						<tr>
                            <th scope="col" jhiTranslate="basic-details.germplasm-origin.progenitor-type">Progenitor Type</th>
							<th scope="col" jhiTranslate="basic-details.germplasm-origin.study">Study</th>
							<th scope="col" jhiTranslate="basic-details.germplasm-origin.obs-unit">Obs_Unit_ID</th>
							<th scope="col" jhiTranslate="basic-details.germplasm-origin.plot">Plot</th>
							<th scope="col" jhiTranslate="basic-details.germplasm-origin.rep">Rep</th>
							<th scope="col" jhiTranslate="basic-details.germplasm-origin.block">Block</th>
							<th scope="col" jhiTranslate="basic-details.germplasm-origin.x">X</th>
							<th scope="col" jhiTranslate="basic-details.germplasm-origin.y">Y</th>
							<th scope="col" jhiTranslate="basic-details.germplasm-origin.observation-unit-type">Observation Unit Type</th>
							<th scope="col" jhiTranslate="basic-details.germplasm-origin.observation-unit-number">Observation Unit Number</th>
						</tr>
						</thead>
						<tbody>
                        <tr *ngFor="let germplasmOrigin of germplasm?.germplasmOrigins">
                        <td>{{germplasmOrigin?.progenitorType}}</td>
                        <td><a *ngIf="germplasmDetailsContext.isModal && isStudyClickable(germplasmOrigin?.programUUID)" href="javascript:void(0)" (click)="openStudy(germplasmOrigin?.studyId, germplasmOrigin?.studyName)" ><truncate-span [textInput]="germplasmOrigin?.studyName"></truncate-span></a>
								<span *ngIf="germplasmDetailsContext.isModal && !isStudyClickable(germplasmOrigin?.programUUID)" class="btn btn-link disabled p-0"><truncate-span [textInput]="germplasmOrigin?.studyName"></truncate-span></span>
								<span *ngIf="!germplasmDetailsContext.isModal"><truncate-span [textInput]="germplasmOrigin?.studyName"></truncate-span></span></td>
							<td>{{germplasmOrigin?.observationUnitId}}</td>
							<td>{{germplasmOrigin?.plotNumber}}</td>
							<td>{{germplasmOrigin?.repNumber}}</td>
							<td>{{germplasmOrigin?.blockNumber}}</td>
							<td>{{germplasmOrigin?.positionCoordinateX}}</td>
							<td>{{germplasmOrigin?.positionCoordinateY}}</td>
							<td>{{germplasmOrigin?.observationUnitType}}</td>
							<td>{{germplasmOrigin?.observationUnitNumber}}</td>
						</tr>
						</tbody>
					</table>
					<ng-template #nogermplasmorigin>
						<table class="table table-striped table-bordered table-curved">
							<thead>
							<tr>
								<th></th>
							</tr>
							</thead>
							<tbody>
							<tr>
								<td jhiTranslate="basic-details.no-germplasm-origin"></td>
							</tr>
							</tbody>
						</table>
					</ng-template>
                    </div>
				</div>
			</div>
            <div class="row" *ngIf="hasGeoCoordinates()">
                <div class="col">
                    <div style="height: 350px; width: 100%" >
                        <jhi-geojson-map [geojsonList]="geoCoordinates()">
                        </jhi-geojson-map>
                    </div>
                </div>
            </div>
		</div>
	</jhi-collapsible>

    <jhi-collapsible heading="{{translateService.instant('basic-details.external-references.title')}}">
        <div class="container-fluid pb-3">
            <div class="row">
                <div class="col">
                    <table class="table table-striped table-bordered table-curved table-fixed"
                        *ngIf="germplasm?.externalReferences.length else nodata">
                        <thead>
                        <tr>
                            <th scope="col" jhiTranslate="basic-details.external-references.reference-id">Reference ID</th>
                            <th scope="col" jhiTranslate="basic-details.external-references.reference-source">Reference Source</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let reference of germplasm?.externalReferences">
                            <td class="word-wrap">{{reference.referenceID}}</td>
                            <td>{{reference.referenceSource}}</td>
                        </tr>
                        </tbody>
                    </table>

                    <ng-template #nodata>
                        <table class="table table-striped table-bordered table-curved">
                            <thead>
                            <tr>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td jhiTranslate="no.data"></td>
                            </tr>
                            </tbody>
                        </table>
                    </ng-template>
                </div>
            </div>
        </div>
    </jhi-collapsible>
</div>
